import {createStore, applyMiddleware} from 'redux';
import { createLogger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';
import { composeWithDevTools } from 'redux-devtools-extension';
import throttle from 'lodash/throttle';
import rootReducer from './reducers';
import rootEpic from './epics';
import { loadState, saveState } from './localStorage';

const loggerMiddleware = process.env.NODE_ENV === 'developlemt' ?
  createLogger() : undefined;
const epicMiddleware = createEpicMiddleware();

let instance = null;

const middlewares = [
  epicMiddleware,
  loggerMiddleware,
].filter(middleware => middleware !== undefined)

function configureStore() {
  const persistedState = loadState();

  if (instance === null){
    instance = createStore(
      rootReducer,
      persistedState,
      composeWithDevTools(applyMiddleware(...middlewares))
    )
    epicMiddleware.run(rootEpic);

    if (process.env.NODE_ENV !== 'production'){
      if (module.hot){
        module.hot.accept('./reducers', ()=>{
          instance.replaceReducer(rootReducer);
        })
      }
    }
  }

  instance.subscribe(throttle(()=> {
    const {
      calculations,
      resins,
      stackup,
      preference
    } = instance.getState();
    saveState({ calculations, resins, stackup, preference });
  }, 1000));

  return instance;
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.js